import moment from "moment";
import {LocaleDictionaryBasic} from "../../interface/basic";

export const basic: LocaleDictionaryBasic = {
    delete : 'Удалить',
    reply : 'Ответить',
    send : 'Отправить',
    cancel : 'Отмена',
    continue : 'Продолжить',
    groups : 'Группы',
    group : 'Группа',
    confirm : 'Подтвердить',
    save : 'Сохранить',
    day1 : 'рабочий день',
    day2 : 'рабочих дня',
    day3 : 'рабочих дней',
    notSelected : 'Не выбрана',
    notSelected2 : 'Не выбран',
    notSelected3 : 'Не выбрано',
    today : 'Сегодня',
    download : 'Скачать',
    footer : '© 2006-' + moment().format('YYYY') + ' Все права защищены «Российский университет дружбы народов»',
    error404 : 'Такой страницы нет',
    error404Text : 'Ссылка, по которой Вы перешли, никуда не ведёт. Вероятно, это произошло из-за опечатки в адресе или эта страница была удалена.',
    error : 'Ошибка',
    errorNoProfile : 'Ваша учётная запись не найдена. Обратитесь в единую службу технической поддержки РУДН',
    phone : 'Телефон',
    email : 'Email',
    details : 'Подробнее',
    noResult : 'По Вашему запросу ничего не найдено'
};